export default "/fonts/vendor/socicon/socicon.woff?fa1cafd691508aa474d6c90fa73cedfe";